<template>

  <head>

    <meta charset="utf-8" />
    <title>Revenue Collection Details | County Management System</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Revenue System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body @contextmenu.prevent data-sidebar="dark">


  <!-- Begin page -->
  <div id="layout-wrapper">


    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                  <h4 class="mb-sm-0 font-size-18">Revenue Collections for {{formatSubCountyName(subCountyName)}}</h4>
                  <p class="text-muted mb-0">Period: {{formatDate(dateFrom)}} to {{formatDate(dateTo)}}</p>
                </div>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a @click="gotTo('dashboard')" href="javascript: void(0)" >Dashboard</a></li>
                    <li class="breadcrumb-item"><a @click="gotTo('reports-sub-county')" href="javascript: void(0)">Reports</a></li>
                    <li class="breadcrumb-item"><a @click="gotTo('reports-sub-county')"  href="javascript: void(0)">Revenue by Sub County</a></li>
                    <li class="breadcrumb-item active">{{formatSubCountyName(subCountyName)}}</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Collection</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-success">KES {{numberFormat(amountTotal)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-success">
                        <span class="avatar-title rounded-circle bg-success">
                          <i class="bx bx-money font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Transactions</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalTransactions)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title rounded-circle bg-primary">
                          <i class="bx bx-receipt font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Average per Transaction</span>
                      <h4 class="mb-3">
                        <span class="counter-value">KES {{getAverageTransaction()}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-info">
                        <span class="avatar-title rounded-circle bg-info">
                          <i class="bx bx-trending-up font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Collection Rate</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-warning">{{getCollectionRate()}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-warning">
                        <span class="avatar-title rounded-circle bg-warning">
                          <i class="bx bx-stats font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- toolbar start -->
          <SubCountyReportsToolBar/>
          <!-- toobar end -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">Transaction Details</h5>
                      <small class="text-muted">Showing {{billDetails.length}} of {{numberFormat(totalTransactions)}} transactions</small>
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex justify-content-end gap-2">
                        <button @click="refreshData()" type="button" class="btn btn-outline-primary btn-sm" :disabled="loading">
                          <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                          {{ loading ? 'Refreshing...' : 'Refresh' }}
                        </button>
                        <button v-if="getRight('DOWNLOAD SUB COUNTY DETAILS TRANSACTION')" @click="downloadReceiptsPaginated()" type="button" class="btn btn-success btn-sm" :disabled="downloading">
                          <i class="bx bx-download"></i> {{download}}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control" placeholder="Search transactions..." />
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex justify-content-end gap-2">
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">From:</label>
                          <input v-model="dateFrom" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">To:</label>
                          <input v-model="dateTo" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5>Loading Transaction Data...</h5>
                    <p class="text-muted">Please wait while we fetch the latest transaction details.</p>
                  </div>

                  <div v-else-if="billDetails.length === 0" class="text-center py-5">
                    <div class="py-4">
                      <i class="bx bx-search-alt-2 font-size-96 text-muted"></i>
                      <h4 class="mt-3">No Transactions Found</h4>
                      <p class="text-muted">No transactions found for the selected criteria. Try adjusting your search or date range.</p>
                      <button @click="clearFilters()" class="btn btn-outline-primary">Clear Filters</button>
                    </div>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 150px;">Receipt No.</th>
                        <th style="width: 120px;">Bill No.</th>
                        <th>Paid By</th>
                        <th style="width: 120px;">Date</th>
                        <th style="width: 120px;">Payment Method</th>
                        <th>Served By</th>
                        <th style="width: 100px;">Status</th>
                        <th class="text-end" style="width: 120px;">Amount</th>
                        <th class="text-center" style="width: 120px;">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in billDetails">
                        <td>
                          <div class="d-flex align-items-center">
                            <span class="badge bg-light text-dark me-2">{{getItemNumber(index)}}</span>
                            <div>
                              <strong class="text-primary">{{item.transactionCode}}</strong>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span class="fw-medium">{{item.billNo || 'N/A'}}</span>
                        </td>
                        <td>
                          <div>
                            <span class="fw-medium">{{item.paidBy}}</span>
                            <br>
                            <small class="text-muted">{{maskPhoneNumber(item.customerPhoneNumber)}}</small>
                          </div>
                        </td>
                        <td>
                          <span class="text-nowrap">{{formatDate(item.dateCreated)}}</span>
                        </td>
                        <td>
                          <span class="badge" :class="getPaymentMethodClass(item.source)">
                            {{item.source}}
                          </span>
                        </td>
                        <td>
                          <span class="fw-medium">{{item.receiptedBy || 'System'}}</span>
                        </td>
                        <td>
                          <span class="badge bg-success">{{item.status}}</span>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <strong class="text-success">KES {{numberFormat(item.receiptAmount)}}</strong>
                            <small class="text-muted">{{getTransactionPercentage(item.receiptAmount)}}%</small>
                          </div>
                        </td>
                        <td class="text-center">
                          <button v-if="getRight('PRINT INVOICE')" @click="printBill(item.billNo,item.subCountyID)"
                                  type="button" class="btn btn-primary btn-sm">
                            <i class="bx bx-printer me-1"></i> Receipt
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card-footer bg-light" v-if="billDetails.length > 0">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div class="d-flex align-items-center gap-2">
                        <span class="text-muted">Show</span>
                        <select class="form-select form-select-sm" v-model="pageSize" style="width: auto;">
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                          <option value="1000">1000</option>
                        </select>
                        <span class="text-muted">entries</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <nav aria-label="Page navigation">
                        <ul class="pagination pagination-sm justify-content-end mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" @click="prevPage" :disabled="currentPage === 1">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                              class="page-item" :class="{ active: currentPage === page }">
                            <span v-if="page === '...'" class="page-link">{{ page }}</span>
                            <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  <!-- Summary Row -->
                  <div class="row mt-3 pt-3 border-top">
                    <div class="col-12">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{{numberFormat(totalTransactions)}} Total Transactions</strong>
                        </div>
                        <div class="text-end">
                          <div class="text-success"><strong>KES {{numberFormat(amountTotal)}}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Transaction Analysis -->
                  <div v-if="billDetails.length > 0" class="mt-4 pt-3 border-top bg-light">
                    <div class="row">
                      <div class="col-md-6">
                        <h6 class="mb-3 text-primary">
                          <i class="bx bx-chart-bar me-2"></i>
                          Payment Method Distribution
                        </h6>
                        <div v-for="method in getPaymentMethodStats()" :key="method.name" class="mb-2">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="fw-medium">{{ method.name }}</span>
                            <span class="text-success">{{ method.count }} ({{ method.percentage }}%)</span>
                          </div>
                          <div class="progress" style="height: 8px;">
                            <div class="progress-bar" :class="method.colorClass"
                                 :style="`width: ${method.percentage}%`">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <h6 class="mb-3 text-info">
                          <i class="bx bx-trending-up me-2"></i>
                          Collection Insights
                        </h6>
                        <ul class="list-unstyled">
                          <li class="mb-2">
                            <i class="bx bx-money text-success me-2"></i>
                            Highest transaction: <strong>KES {{ getHighestTransaction() }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-chart-line text-primary me-2"></i>
                            Average per transaction: <strong>KES {{ getAverageTransaction() }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-time text-warning me-2"></i>
                            Collection period: <strong>{{ getCollectionPeriod() }} days</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-trending-up text-info me-2"></i>
                            Daily average: <strong>KES {{ getDailyAverage() }}</strong>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Developed by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>

</template>

<script>
/* eslint-disable */
import {biller, execute, executeDownload, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import SubCountyReportsToolBar from "@/components/reports/collectionbysubcounties/SubCountyReportsToolBar";
import moment from 'moment';

export default {
  name: "SubCountyReportDetails",
  components: {SubCountyReportsToolBar, NavigationBar},
  data() {
    return {
      download:'Download Report',
      downloading: false,
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems:0,
      subCountyName:'',
      subCountyID:'',
      dateRange:'',
      dateTo:'',
      dateFrom:'',
      search:'',
      totalAmount:null,
      amountTotal: 0,
      totalTransactions: 0,
      billDetails: [],
      billInfo: [],
      totalAgents: 0,
    };
  },
  watch: {
    pageSize(newPageSize) {
      this.getReceiptsPaginatedBySubCounty()
      const totalItems = this.totalItems;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },

    search(){
      this.currentPage = 1;
      this.getReceiptsPaginatedBySubCounty()
    },
  },
  computed:{
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
  },
  mounted() {
    this.subCountyID = sessionStorage.getItem("subCountyID")
    this.subCountyName = sessionStorage.getItem("subCountyName")
    this.dateTo = sessionStorage.getItem("dateTo")
    this.dateFrom = sessionStorage.getItem("dateFrom")
    this.search = this.subCountyName
    this.totalAgents = sessionStorage.getItem("totalAgents")

    this.getReceiptsPaginatedBySubCounty()

    this.$watch('dateFrom', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {
        return;
      } else {
        this.currentPage = 1;
        this.getReceiptsPaginatedBySubCounty()
      }
    })

    this.$watch('dateTo', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {
        return;
      } else {
        this.currentPage = 1;
        this.getReceiptsPaginatedBySubCounty()
      }
    })

    this.menuAccess()
  },
  methods: {

    // Helper methods for better UX
    formatSubCountyName(name) {
      if (!name || name === 'undefined') return 'Unknown';
      return name.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    getItemNumber(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },

    getAverageTransaction() {
      if (this.totalTransactions === 0) return '0';
      return this.numberFormat(Math.round(this.amountTotal / this.totalTransactions));
    },

    getCollectionRate() {
      // Calculate transactions per day
      const days = this.getCollectionPeriod();
      if (days === 0) return '0/day';
      return Math.round(this.totalTransactions / days) + '/day';
    },

    getCollectionPeriod() {
      if (!this.dateFrom || !this.dateTo) return 0;
      return moment(this.dateTo).diff(moment(this.dateFrom), 'days') + 1;
    },

    getDailyAverage() {
      const days = this.getCollectionPeriod();
      if (days === 0) return '0';
      return this.numberFormat(Math.round(this.amountTotal / days));
    },

    getHighestTransaction() {
      if (this.billDetails.length === 0) return '0';
      const highest = Math.max(...this.billDetails.map(item => Number(item.receiptAmount)));
      return this.numberFormat(highest);
    },

    getTransactionPercentage(amount) {
      if (this.amountTotal === 0) return '0.0';
      return ((Number(amount) / this.amountTotal) * 100).toFixed(1);
    },

    getPaymentMethodClass(method) {
      const classes = {
        'MPESA': 'bg-success',
        'CASH': 'bg-warning text-dark',
        'BANK': 'bg-info',
        'CHEQUE': 'bg-secondary'
      };
      return classes[method?.toUpperCase()] || 'bg-primary';
    },

    getPaymentMethodStats() {
      const methods = {};
      this.billDetails.forEach(item => {
        const method = item.source || 'UNKNOWN';
        methods[method] = (methods[method] || 0) + 1;
      });

      const total = this.billDetails.length;
      const colors = ['bg-success', 'bg-warning', 'bg-info', 'bg-secondary', 'bg-primary'];

      return Object.entries(methods).map(([name, count], index) => ({
        name,
        count,
        percentage: total > 0 ? ((count / total) * 100).toFixed(1) : 0,
        colorClass: colors[index % colors.length]
      })).sort((a, b) => b.count - a.count);
    },

    refreshData() {
      this.getReceiptsPaginatedBySubCounty();
    },

    clearFilters() {
      this.search = this.subCountyName;
      this.currentPage = 1;
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "All Transactions");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
            // Success
          })
          .catch((e) => {
            console.error("Menu access error:", e);
          });
    },

    getRight(type){
      return getRight(type)
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getReceiptsPaginatedBySubCounty()
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getReceiptsPaginatedBySubCounty()
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getReceiptsPaginatedBySubCounty()
      }
    },

    gotTo(route){
      this.$router.push(route);
    },

    formatDate(date) {
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    printBill(billNo,subCountyID) {
      if (!subCountyID || subCountyID === '') {
        alert(`The payment does not have an associated invoice. It was made directly to the MPESA Paybill with no invoice or an incorrect reference number. (${billNo})`);
        return;
      } else {
        localStorage['params'] = JSON.stringify({
          billNo: billNo
        })
        const routeData = this.$router.resolve({name: 'bill'});
        window.open(routeData.href, '_blank');
      }
    },

    getReceiptsPaginatedBySubCounty() {
      this.billDetails.splice(0)
      this.loading = true

      const data = new FormData();
      data.append("function", "getReceiptsPaginatedBySubCounty");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.search)
      data.append("subCountyID", this.subCountyID)

      execute(data, biller)
          .then((res) => {
            this.loading = false

            if (res.data.success) {
              this.billDetails = res.data.data.billDetails || []

              this.totalItems = res.data.data.summary?.count || 0
              this.totalPages = Math.ceil(this.totalItems / this.pageSize);

              this.totalTransactions = res.data.data.summary?.count || 0
              this.amountTotal = Number(res.data.data.summary?.total || 0)

              // Calculate total from current page items as fallback
              this.totalAmount = this.billDetails.reduce((acc, cur) => {
                let receiptAmount = Number(cur.receiptAmount);
                return acc + receiptAmount;
              }, 0);

            } else {
              console.log("API returned success: false", res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("API Error:", e);
            alert("Failed to load transaction data. Please check your connection and try again.");
          });
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    },

    downloadReceiptsPaginated(){
      this.downloading = true;
      this.download = "Downloading... Please wait"

      const data = new FormData();
      data.append("function", "downloadReceiptsPaginated");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCountyID", this.subCountyID)

      executeDownload(data,biller)
          .then(response => {
            this.download = "Download Report"
            this.downloading = false;

            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = `${this.dateFrom}_to_${this.dateTo}_${this.formatSubCountyName(this.subCountyName)}_transactions.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(e => {
            this.download = "Download Report"
            this.downloading = false;
            console.error("Download error:", e);
            alert("Failed to download report. Please try again.");
          });
    },
  }
}
</script>

<style scoped>
.card-h-100 {
  height: 100%;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 600;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.bx-spin {
  animation: spin 1s linear infinite;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.progress {
  background-color: #f3f3f3;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>